import { useRef, useEffect, useState, useCallback } from 'react';
import { GameLoop } from '../game/engine/GameLoop';
import { GameState, GamePhase, Direction } from '../game/types';

export function useGame(canvasRef: React.RefObject<HTMLCanvasElement | null>) {
  const gameRef = useRef<GameLoop | null>(null);
  const [state, setState] = useState<GameState | null>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const game = new GameLoop(canvas);
    gameRef.current = game;

    const unsub = game.onStateChange((s) => setState({ ...s }));
    game.start();
    setState(game.getState());

    return () => {
      unsub();
      game.stop();
      gameRef.current = null;
    };
  }, [canvasRef]);

  const setDirection = useCallback((dir: Direction) => {
    gameRef.current?.getInputManager().setDirection(dir);
  }, []);

  const getSoundManager = useCallback(() => {
    return gameRef.current?.getSoundManager() ?? null;
  }, []);

  return { state, setDirection, getSoundManager };
}
